export default "__VITE_ASSET__Cd_DDrS0__"